import React from 'react'
import empty from '../img/empty.png'
import './picture.css'

/**
 * Avatar
 */
const Avatar = ({ src, name = "x" }) => {
  return (
    <picture className="avatar" title={name}>
      { src ? <img src={`${src}`} title={name}/> : <div>{name.charAt(0)}</div> }
    </picture>
  )
}

/**
 * Thumb
 */
const Thumb = ({ src, alt }) => {

  const url = src ? src === 'empty' ? empty : src : empty

  const renderAlt = () => {
    return (
      <div className="thumb alt">
        {alt}
      </div>
    )
  }

  const renderPicture = () => {
    const alternative = alt ? alt : 'empty'
    return (
        <img className="thumb" src={url} alt={alternative} onError={(e)=>{e.target.className="error"}} />
    )
  }

  return src ? renderPicture() : alt ? renderAlt() : renderPicture()
}

/**
 * Picture
 */
const Picture = ({ src, alt }) => {

  const url = src ? src === 'empty' ? empty : src : empty

  const renderAlt = () => {
    return (
      <div className="picture alternative">
        {alt}
      </div>
    )
  }

  const renderPicture = () => {
    const alternative = alt ? alt : 'empty'
    return (
      <picture className="picture">
        <img src={url} alt={alternative}/>
      </picture>
    )
  }

  return src ? renderPicture() : alt ? renderAlt() : renderPicture()
}

export { Avatar, Thumb, Picture }



// WEBPACK FOOTER //
// ./src/lib/components/picture.js